export type KycProfileStatus = string | null | undefined;

export type KycProfileLike = {
  is_verified?: boolean | null;
  is_admin_verified?: boolean | null;
  admin_bypass_kyc?: boolean | null;
  verification_status?: KycProfileStatus;
  verification_submitted_at?: string | null;
  selfie_url?: string | null;
} | null | undefined;

const APPROVED_KYC_STATUSES = new Set(["approved", "verified"]);

export function normalizeKycStatus(status: KycProfileStatus) {
  return String(status ?? "").trim().toLowerCase();
}

export function isProfileKycVerified(
  profile: KycProfileLike,
  options?: { isPrivilegedAdmin?: boolean },
) {
  if (options?.isPrivilegedAdmin) return true;
  if (!profile) return false;

  const status = normalizeKycStatus(profile.verification_status);
  return (
    profile.is_verified === true ||
    profile.is_admin_verified === true ||
    profile.admin_bypass_kyc === true ||
    APPROVED_KYC_STATUSES.has(status)
  );
}

export function hasProfileSubmittedKyc(profile: KycProfileLike) {
  return !!profile?.verification_submitted_at && !!profile?.selfie_url;
}

export function isProfileVerificationPending(profile: KycProfileLike) {
  return hasProfileSubmittedKyc(profile) && normalizeKycStatus(profile?.verification_status) === "pending";
}

export function needsProfileKycVerification(
  profile: KycProfileLike,
  options?: { hasUser?: boolean; isLoading?: boolean; isPrivilegedAdmin?: boolean },
) {
  return Boolean(
    options?.hasUser &&
      !options?.isLoading &&
      profile &&
      !isProfileKycVerified(profile, { isPrivilegedAdmin: options?.isPrivilegedAdmin }) &&
      !hasProfileSubmittedKyc(profile),
  );
}